<template>
  <div class="card">
    <div class="card-body">
      <b-table
          :items="purchaseOrders"
          :fields="purchaseOrdersHeaders"
          :busy="purchaseOrdersLoading"
          hover
          show-empty
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          head-row-variant="info"
          table-variant="white"
      >
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : noPurchaseOrdersMessage }}
          </h6>
        </template>
        <template #cell(date)="data">
          {{ formattedDate(data.item.date, "DD-MM-YYYY") }}
        </template>
        <template #cell(subTotal)="data">
          {{ numberConverter(data.item.subTotal) }}
        </template>
        <template #cell(grossAmount)="data">
          {{ numberConverter(data.item.grossAmount) }}
        </template>
        <template #cell(vat)="data">
          {{ numberConverter(data.item.vat) }}
        </template>
        <template #cell(totalAmount)="data">
          {{ numberConverter(data.item.totalAmount) }}
        </template>
        <template #cell(amount)="data">
          {{ formattedDate(data.item.date, "DD-MM-YYYY") }}
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Text Centered"
            ></b-spinner>
          </div>
        </template>
        <template #cell(process)="data">
          <div>
            <v-menu
                :v-model="showActionsMenu"
                bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="mx-1"
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click="showActionsMenu = data.item.code"
                >
                  İşlemler
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                    @click="openPurchaseOrderDetailDialog(data.item.id)"
                >
                  <v-list-item-icon>
                    <v-icon color="primary">mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Detaylar</v-list-item-title>
                </v-list-item>

                <v-list-item
                    @click="_deletePurchaseOrder(data.item.id)"
                >
                  <v-list-item-icon>
                    <v-icon color="amber">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Siparişi Sil</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </b-table>
      <PurchaseOrderDetailDialog :show-dialog="showPurchaseOrderDetailDialog" @dialogChange="(e) => (showPurchaseOrderDetailDialog = e)"></PurchaseOrderDetailDialog>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import {formattedDate} from "@/momentHelper";
import PurchaseOrderDetailDialog from "@/components/orders/PurchaseOrders/dialogs/PurchaseOrderDetailDialog.vue";
import {numberConverter} from "../../../../../helpers";

export default {
  components: {
    PurchaseOrderDetailDialog
  },
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  computed: {
    ...mapState("order", ["purchaseOrders", "purchaseOrdersHeaders", "purchaseOrdersLoading","purchaseOrdersMetaData","noPurchaseOrdersMessage","purchaseOrdersLoading"]),
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      selectRow: false,
      showActionsMenu: false,
      showPurchaseOrderDetailDialog: false,

    };
  },
  methods: {
    numberConverter,
    formattedDate,
    ...mapActions("order", ["fetchSinglePurchaseOrder","deletePurchaseOrder"]),
    async openPurchaseOrderDetailDialog(id) {
      this.showPurchaseOrderDetailDialog = true;
      await this.fetchSinglePurchaseOrder({params: {} , body:{}, urlSegments:[id] })
    },
    async _fetchSinglePurchaseOrder() {
      await this.fetchSinglePurchaseOrder({params: {} , body:{}, urlSegments:[this.purchaseOrderItemDetails.id] })
    },
    async _deletePurchaseOrder(id) {
      await this.deletePurchaseOrder({
        params: {orderId: id},
        body:{}
      }).then(async () => {
        await this.$parent._fetchPurchaseOrders();
      })
    },
    closeMenu() {
      this.showActionsMenu = false;
    },
  },
  watch: {

  },
};
</script>
